export type PreviewStatus = "idle" | "loading" | "success" | "error" | "warning";

export type LoadingSource = "preview" | "export" | "source-code" | null;

/**
 * The word the Preview button grows to show for a result. Short on purpose — the bar is a fixed
 * band. A run in flight shows no words at all: the spinner says it, and the codegen stream reports
 * no steps or percentage worth reading.
 */
const RESULT_LABELS: Record<Exclude<PreviewStatus, "idle" | "loading">, string> = {
  success: "Ready",
  error: "Failed",
  warning: "Busy"
};

/**
 * The word the button grows to show, or null while it is an icon — at rest, during a run, and
 * after a run the publish popover started (export, source download): those report in the popover,
 * and "Ready" on the Preview button would claim a preview that never ran.
 */
export const getRunStatusLabel = (status: PreviewStatus, source: LoadingSource): string | null => {
  if (status === "idle" || status === "loading") return null;
  if (source !== "preview") return null;
  return RESULT_LABELS[status];
};
